var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoviesNews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 9.975,
    viewBox: "0 0 18 9.975",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Movies_News",
    "data-name": "Movies News",
    transform: "translate(-1 -7.688)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9011",
    "data-name": "Path 9011",
    d: "M18.421,8.253a1.187,1.187,0,0,0-1.178-.036l-2.77,1.452V9.488a1.8,1.8,0,0,0-1.8-1.8H2.8A1.8,1.8,0,0,0,1,9.488v6.375a1.8,1.8,0,0,0,1.8,1.8h9.873a1.8,1.8,0,0,0,1.8-1.8v-.181l2.77,1.452A1.2,1.2,0,0,0,19,16.071V9.279A1.19,1.19,0,0,0,18.421,8.253Zm-5.148,7.61a.6.6,0,0,1-.6.6H2.8a.6.6,0,0,1-.6-.6V9.488a.6.6,0,0,1,.6-.6h9.873a.6.6,0,0,1,.6.6v6.375Zm4.527.208-3.327-1.744v-3.3L17.8,9.279l0,6.792Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoviesNews);
export default __webpack_public_path__ + "static/media/Movies-News.19226c5cf0356b45bb8348736c66e120.svg";
export { ForwardRef as ReactComponent };